import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-customer.dto';
export * from './dtos/customers-stats.dto';
export * from './dtos/customer-list.dto';
export * from './dtos/customer-record.dto';
export * from './dtos/customer-activity-event.dto';
export * from './dtos/customer-activity-event-hydration.dto';
export * from './dtos/customer-search.dto';
export * from './dtos/update-customer.dto';

export * from './enums/customer-status.enum';
export * from './enums/customer-type.enum';
export * from './enums/customer-action.enum';

export * from './functions/customer-status-to-color.function';

export * from './types/customers-filters';

export * from './validators/schemas/create-customer.schema';
export * from './validators/schemas/update-customer.schema';

export const customerValidators = { canCreateOrUpdate, canPerformAction };
